import SalesOrderInboundMessagesPage from "../../pages/legacy/salesOrderInboundMessages/SalesOrderInboundMessagesPage";

const route = {
  key: "salesOrderInboundMessages",
  path: "/legacy/sales-order-inbound-messages",
  component: SalesOrderInboundMessagesPage,
  private: true,
  layout: "main",
  icon: "faEnvelopeOpenText",
  group: "sales",
  order: 22,
  permission: "legacy.salesOrderInboundMessages.read"
};

export default route;